import * as React from 'react';
import {
  Button,
  Image,
  Menu,
  Responsive
} from 'semantic-ui-react';
import { getI18n } from 'services/i18n-service';
import { hasPermissionTo } from 'helpers/permission-helper';
import { Link, RouteComponentProps } from 'react-router-dom';
import { NmvsActionType } from 'types/nmvs-action-type';
import { Mode } from 'types/mode';
import { LanguageCode } from 'types/tenants/language-code';
import { NmvsMenuItem } from 'types/nmvs-menu-item';

import './styles.css';

export interface ConnectedProps {
  operations: NmvsMenuItem[];
  permissions: string;
  currentOperation: NmvsMenuItem;
  isOnline: boolean;
  language: LanguageCode;
}

export interface ActionProps {
  selectOperation: (operation: NmvsMenuItem) => void;
  closeMenu: () => void;
}

export type Props = ConnectedProps & ActionProps & RouteComponentProps;
export class CertaMenu extends React.Component<Props> {

  private i18n = getI18n();

  public render() {

    return (
      <>
        <Menu.Item header={true} className="menu-app-title main-logo" as={Link} to={`${process.env.PUBLIC_URL}/`}>
          <Responsive {...Responsive.onlyMobile} className="inline-button-container">
            <Button icon="x" className="close-menu mobile-button" onClick={this.props.closeMenu} />
          </Responsive>
          <span className="menu-item-title">
            <span className="slim-text">OPTEL</span><br/>Product Explorer&trade;
          </span>
        </Menu.Item>
        {
          this.props.operations.map((operation) => {
            let isMenuOperationAllowed: boolean = false;
            isMenuOperationAllowed = hasPermissionTo([Mode.Read], operation.requiredPermission, this.props.permissions);

            if (isMenuOperationAllowed) {
              const active = this.props.currentOperation.text === operation.text && this.props.location.pathname === '/';
              const isDisabled = this.props.isOnline !== true &&
                (operation.nmvsOperation === NmvsActionType.UndoDispense
                  || operation.nmvsOperation === NmvsActionType.UndoSample);
              return <Menu.Item
                as={Link}
                to={`${process.env.PUBLIC_URL}/`}
                className="menu-item"
                key={operation.nmvsOperation}
                name={operation.text}
                active={active}
                disabled={isDisabled}
                onClick={() => this.props.selectOperation(operation)} >
                <Image className="menu-icon" name={operation.text}
                  src={'./icons/menu/' + (active ? 'inverted/' : '') +
                    NmvsActionType[operation.nmvsOperation].toLowerCase() + '.svg'} />
                <span className="menu-item-title">{this.i18n.t(operation.text)}</span>
              </Menu.Item>;
            } else {
              return null;
            }
          })
        }
      </>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/menu/component.tsx